<template>
  <div class="app-container">
    <div class="content-wrapper">
      <!-- 左侧图片区 -->
      <div class="left-column">
        <div class="image-wrapper">
          <div class="image-container">
            <el-image :src="detail.workMedia" class="fit-image"></el-image>
            <div class="comment-level" v-if="detail.commentLevel">
              <el-image 
                :src="`/images/${getLevelImageName(detail.commentLevel)}.png`"  
                class="level-img"
                fit="contain"
                :alt="detail.commentLevel">
              </el-image>
            </div>
          </div>
          <div class="image-text">{{ detail.workTitle }}</div>
        </div>
      </div>

      <!-- 右侧信息区 -->
      <div class="right-column">
        <div class="info-container">
          <!-- 学生信息卡片 -->
          <div class="info-card">
            <div class="card-header">
              <span class="info-label title-label">学生信息</span>
            </div>
            <div class="card-body">
              <div class="info-row">
                <span class="info-label">姓名:</span>
                <span class="info-content">{{ detail.nickName }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">性别:</span>
                <span class="info-content">{{ detail.sex }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">年龄:</span>
                <span class="info-content">{{ detail.age }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">籍贯:</span>
                <span class="info-content">{{ detail.address }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">班级:</span>
                <span class="info-content">{{ detail.className || '' }}</span>
              </div>
            </div>
          </div>

          <!-- 作品信息卡片 -->
          <div class="info-card">
            <div class="card-header">
              <span class="info-label title-label">作品相关信息</span>
            </div>
            <div class="card-body">
              <div class="info-row">
                <span class="info-label">作品编号:</span>
                <span class="info-content">OMD{{ detail.id }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">作品名称:</span>
                <span class="info-content">{{ detail.workTitle }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">所属专业:</span>
                <span class="info-content">{{ detail.majorName }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">所属阶段:</span>
                <span class="info-content">{{ detail.xueQi }} {{detail.stage}}</span>
              </div>
              <div class="info-row highlight">
                <span class="info-label">指导老师:</span>
                <span class="info-content" v-if="detail.teacherName">{{ detail.teacherName }}</span>
                <span class="info-content no-data" v-else>暂无老师点评</span>
              </div>
              <div class="info-row">
                <span class="info-label">创作日期:</span>
                <span class="info-content">{{ detail.workScreatetime }}</span>
              </div>
              <div class="info-row highlight">
                <span class="info-label">作品点评:</span>
                <span class="info-content" v-if="detail.commentContent">{{ detail.commentContent}}</span>
                <span class="info-content no-data" v-else>暂无点评</span>
              </div>
            </div>
          </div>
          
          <!-- 导航按钮区 -->
          <div class="nav-buttons">
            <el-button 
              type="primary" 
              icon="el-icon-arrow-left" 
              :disabled="currentSourceIndex === 0"
              @click="handlePrevClick">
              上一个
            </el-button>
            <el-button 
              type="primary" 
              icon="el-icon-arrow-right" 
              :disabled="currentSourceIndex === currentSourceWorks.length - 1"
              @click="handleNextClick">
              下一个
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWorkDetail } from '@/api/Works/works';
export default {
  data() {
    return {
      detail: {
        id:'',
        nickName:'',
        className:'',
        teacherName:'',
        majorName:'',
        commentContent:'',
        commentLevel:'',
        workTitle:'',
        sex:'',
        age:'',
        workMedia:'',
        address:'',
        stage:'',
        xueQi:'',
        workScreatetime:''
      }, 
      currentSourceWorks: [], // 当前来源对应的作品列表（动态赋值）
      currentSourceIndex: 0, // 当前作品在当前来源列表中的索引（动态赋值）
    }
  },
  
  mounted() {
    const myWorksStr = sessionStorage.getItem('myWorks_worksList');
    this.currentSourceWorks = myWorksStr ? JSON.parse(myWorksStr) : [];
    console.log('作品列表长度：', this.currentSourceWorks.length);
    this.currentSourceIndex = Number(sessionStorage.getItem('myWorks_currentIndex')) || -1;
    this.setImage();
  },
  
  methods: {
    // 将中文评价等级转换为对应的图片文件名
    getLevelImageName(level) {
      const levelMap = {
        '合格': 'hege',
        '优秀': 'youxiu',
        '留校': 'liuxiao',
        '良好': 'lianghao'
      };
      return levelMap[level] || '';
    },
    
    // 上一副
    handlePrevClick() {
      if(this.currentSourceIndex>0){
        this.currentSourceIndex--;
      }
      else{
        this.currentSourceIndex=0;
        this.$message.error('已经是第一个作品');
      }
      this.switchWork();
    },
    
    // 下一副
    handleNextClick() {
      if(this.currentSourceIndex<this.currentSourceWorks.length-1){
        this.currentSourceIndex++;
      }
      else{
        this.currentSourceIndex=this.currentSourceWorks.length-1;
        this.$message.error('已经是最后一个作品');
      }
      this.switchWork();
    },
  
    // 切换到目标作品
    switchWork() {
      const targetWork = this.currentSourceWorks[this.currentSourceIndex];
      if (!targetWork) {
        this.$message.error('没有找到对应作品');
        return;
      }
      getWorkDetail(targetWork.id).then(res => {
        if (res.code === 200) {
          this.detail = res.data;
        } else {
          this.$message.error('获取作品详情失败');
        }
      });
    },
    
    setImage() {
      const id = sessionStorage.getItem('workId');
      getWorkDetail(id).then((res) => {
        console.log('当前作品ID：', id);
        console.log(res);
        if (res.code === 200) {
          this.detail = res.data;
          console.log('获取作品详情成功：', res.data);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.error('获取作品详情失败：', err);
      });
    }
  }
}
</script>

<style scoped>
/* 整体布局优化 */
.app-container {
  padding: 0 20px 0 20px;
  min-height: calc(100vh - 40px);
  display: flex;
 
}

.content-wrapper {
  display: flex;
  width: 95%;
  max-width: 1200px;
  gap: 20px;
 
}

/* 左右分栏比例调整 */
.left-column {
  width: 30%;
  display: flex;
  height: 100%;
  
}

.right-column {
  width: 70%;
}

.info-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 图片区域优化 */
/* 图片容器 - 使用aspect-ratio确保宽高比一致 */
.image-wrapper {
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 
              0 6px 20px rgba(224, 34, 77, 0.08);
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height:fit-content;
}

.image-wrapper img {
  vertical-align: bottom; /* 底部对齐，消除下方空白 */
}

.image-container {
  position: relative;
  aspect-ratio: 4/3; /* 使用现代宽高比属性 */
  background-color: #f9f9f9;
}

.fit-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保图片始终填充容器 */
  display: block; /* 避免图片下方间隙 */
}

/* 评价标志 - 确保跨浏览器兼容 */
.comment-level {
  position: absolute;
  right: 5px;
  bottom: 5px;
  z-index: 10;
  width: 22%; /* 响应式大小 */
  max-width: 90px; /* 最大尺寸 */
  min-width: 60px; /* 最小尺寸 */
  height: auto; /* 高度自适应 */
  aspect-ratio: 1/1; /* 保持正方形 */
}

.level-img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 确保图片完整显示 */
}

.image-text {
  text-align: center;
  padding: 10px;
  color: #de336c;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  flex-shrink: 0; /* 防止文字区域压缩 */
}

/* 信息卡片紧凑优化 */
.info-card {
  margin-bottom: 15px;
  overflow: hidden;
}

/* 卡片标题栏（含左侧红色竖杠） */
.card-header {
  padding: 12px 15px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #e9ecef;
  /* 关键：给伪元素留出定位空间 */
  
}


.title-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #409EFF;
}

.card-body {
  padding: 12px 15px;
}

/* 信息行紧凑布局 */
.info-row {
  display: flex;
  margin: 8px 0;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eee;
  line-height: 1.4;
}

.info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.info-label {
  font-weight: 600;
  color: #333;
  min-width: 70px;
  margin-right: 8px;
  font-size: 0.95rem;
}

.info-content {
  flex-grow: 1;
  word-break: break-word;
  color: #666;
  font-size: 0.95rem;
}

/* 导航按钮位置优化 */
.nav-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 15px;
}

.nav-buttons .el-button {
  padding: 10px 20px;
  font-size: 0.95rem;
}

/*按钮的样式 主要按钮 的样式*/

::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
  ;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 表格中的文字 */
/* ::v-deep .el-button--text  {
  color: var(--primary-color);
}   */


::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框 初始边框
::v-deep .el-input__inner,.el-textarea__inner {
  border:1px solid var(--primary-color);
} */
/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}
/* 响应式调整 */
@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .left-column, 
  .right-column {
    width: 100%;
    max-width: 600px;
  }
}

@media (max-width: 768px) {
  .app-container {
    padding: 10px;
  }
  
  .content-wrapper {
    width: 100%;
  }
  
  .card-header {
    padding: 10px;
  }
  
  .card-body {
    padding: 10px;
  }
  
  .info-row {
    flex-direction: column;
  }
  
  .nav-buttons .el-button {
    width: 48%;
    padding: 8px 15px;
  }
}

@media (max-width: 480px) {
  .image-text {
    font-size: 1rem;
    padding: 8px;
  }
  
  .title-label {
    font-size: 1rem;
  }
  
  .info-label, 
  .info-content {
    font-size: 0.9rem;
  }
}
</style>